<template>
  <div id="app">
    
    <HeaderComponent />
    
    
    
      <router-view />
    
  </div>
</template>

<script>
// Importation du composant Header
import HeaderComponent from '@/components/HeaderComponent.vue';

export default {
  name: 'App',
  components: {
    HeaderComponent,
  },

  mounted() {
    // Réinitialise le scroll en haut de la page quand ce composant est monté
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Raleway", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: normal;
  font-size: 1em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  padding-top: 60px; /* Ajouter un espacement au contenu sous le header fixe */
}

nav {
  padding: 30px;
  
  a {
    font-weight: 600;
    font-size: 1.6em;

    &.router-link-exact-active {
      color: #22523f;
    }
  }
}
</style>
